import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import LandingPage from './pages/LandingPage';
import SuccessPage from './pages/SuccessPage';
import ReadingPage from './pages/ReadingPage';
import SubscriptionSuccess from './pages/SubscriptionSuccess';

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <Toaster 
        position="top-center" 
        theme="dark"
        toastOptions={{
          style: {
            background: '#0A0A16',
            border: '1px solid #D4AF37',
            color: '#E2E2E2',
          },
          className: 'sonner-toast',
        }}
        richColors
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/reading/:readingId" element={<ReadingPage />} />
          <Route path="/subscription-success" element={<SubscriptionSuccess />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
